import { axiosAuth, axiosNoAuth } from '../../config/axiosInstances';
import { Api_url } from '../../common/api_url';
import { API_XANO_BASE_URL, API_XANO_AUTH_BASE_URL } from '../../config/api_config';
import axios from 'axios';
import { LOGOUT_REQUEST } from './types';

export function getCertificate(
  user_id,
  mskill_slug,
  successCallback,
  errorCallback
) {
  return async function (dispatch) {
    try {
      if(user_id ===0 || user_id === null || user_id ===undefined)
      {
        successCallback && successCallback({});
      }
      else{
      let response = await axiosAuth.post(
        'https://xgfy-czuw-092q.m2.xano.io/api:certificate/create',
        {
            certificate_type: 'mskill',
            slug : mskill_slug,
        
        }
      );
      successCallback && successCallback(response.data.data);
      }
    } catch (e) {
      console.error(e);
      errorCallback && errorCallback(e.response.data.message);
    }
  };
}

export function getCertificates(user_id, successCallback, errorCallback) {
  return async function (dispatch) {
    try {
      let response = await axiosAuth.get(
        'https://xgfy-czuw-092q.m2.xano.io/api:certificate/all',
        {
          params: {
            certificate_type: 'mskill',
          },
        }
      );
      successCallback && successCallback(response.data.data);
    } catch (e) {
      console.error(e);
      errorCallback && errorCallback(e.response.data.message);
    }
  };
}

export function unlockCertificate(user_id, mskill_slug, successCallback, errorCallback) {
  return async function (dispatch) {
    try {
      const response = await axiosAuth.post(API_XANO_AUTH_BASE_URL + Api_url.UnlockCertificate, {
        user_id,
        mskill_slug
      })
      console.log(response.data);
      successCallback && successCallback(response.data);
    } catch (err) {
      console.log(err)
      errorCallback && errorCallback(err)
    }
  }
}

export function getCertificateStatus(user_id, mskill_slug, successCallback, errorCallback) {
  return async function (dispatch) {
    try {

      const response = await axiosAuth.get(API_XANO_AUTH_BASE_URL + Api_url.GetCertificateStatus, {
        params: {
          user_id,
          mskill_slug
        }
      })
      successCallback && successCallback(response.data);

    } catch (err) {
      console.log(err)
      errorCallback && errorCallback(err)
    }
  }
}

export function GetCertificatesByStatus(user_id, status, successCallback, errorCallback) {
  return async function (dispatch) {
    try {

      const response = await axiosAuth.get(API_XANO_BASE_URL + Api_url.GetCertificatesByStatus, {
        params: {
          user_id,
          status
        }
      })
      successCallback && successCallback(response.data);

    } catch (err) {
      console.log(err)
      errorCallback && errorCallback(err)
    }
  }
}

export function getCertificateLink(
  unique_certificate_id,
  file_type,
  successCallback,
  errorCallback
) {
  return async function (dispatch) {
    try {
      if(file_type === 'image_png'){
        let response = await axiosAuth.get(
          'https://xgfy-czuw-092q.m2.xano.io/api:certificate/file',
          { 
            params: {
              certificate_type : "mskill",
              unique_certificate_id,
              file_type
            },
          }
        );
        console.log(response);
        successCallback && successCallback(response.data.data);
      }
      else{
        let response = await axiosAuth.get(
          'https://xgfy-czuw-092q.m2.xano.io/api:certificate/file',
          { 
            params: {
              certificate_type : "mskill",
              unique_certificate_id,
              file_type
            },
          }
        );
        //console.log(response);
        successCallback && successCallback(response.data.data);

      }
     
    } catch (e) {
      console.error(e);
      errorCallback && errorCallback(e.response.data.message);
    }
  };
}

export function getShareCertificateLink(
  unique_certificate_id,
  return_type,
  successCallback,
  errorCallback
) {
  return async function (dispatch) {
    try {
      if(return_type === 'link'){
        let response = await axiosNoAuth.get(
          API_XANO_AUTH_BASE_URL + Api_url.GetShareCertificateLink,
          { 
            params: {
              unique_certificate_id,
              return_type
            },
          }
        );
        console.log(response);
        successCallback && successCallback(response.data);
      }
      else{
        let response = await axiosNoAuth.get(
          API_XANO_AUTH_BASE_URL + Api_url.GetShareCertificateLink,
          { 
          responseType: 'arraybuffer',
          headers: {
            'Accept': 'image/jpeg'
          },
            params: {
              unique_certificate_id,
              return_type
            },
          }
        );
        //console.log(response);
        successCallback && successCallback(response.data);

      }
     
    } catch (e) {
      console.error(e);
      errorCallback && errorCallback(e.response.data.message);
    }
  };
}

export function getNodeShareCertificateLink(
  unique_certificate_id,
  successCallback,
  errorCallback
) {
  return async function (dispatch) {
    try {
        let response = await axiosNoAuth.get(
          'https://xgfy-czuw-092q.m2.xano.io/api:shorts/knowledge_graph/shared_certificate',
          { 
          responseType: 'arraybuffer',
          headers: {
            'Accept': 'image/jpeg'
          },
            params: {
              unique_certificate_id,
            },
          }
        );
        //console.log(response);
        successCallback && successCallback(response.data);
     
    } catch (e) {
      console.error(e);
      errorCallback && errorCallback(e);
    }
  };
}


export function getCertificateDetails(unique_certificate_id, successCallback, errorCallback) {
  return async function (dispatch) {
    try {

      const response = await axiosAuth.get(API_XANO_AUTH_BASE_URL + Api_url.GetCertificateDetails, {
        params: {
          unique_certificate_id
        }
      })

      successCallback && successCallback(response.data)

    } catch (e) {
      console.error(e);
      errorCallback && errorCallback(e.response.data.message);
    }
  }
}


export function getShareCertificateDetails(unique_certificate_id, successCallback, errorCallback) {
  return async function (dispatch) {
    try {

      const response = await axiosNoAuth.get(API_XANO_AUTH_BASE_URL + Api_url.GetShareCertificateDetails, {
        params: {
          unique_certificate_id
        }
      })

      successCallback && successCallback(response.data)

    } catch (e) {
      console.error(e);
      errorCallback && errorCallback(e.response.data.message);
    }
  }
}

export function getNodeShareCertificateDetails(unique_certificate_id, successCallback, errorCallback) {
  return async function (dispatch) {
    try {

      const response = await axiosNoAuth.get('https://xgfy-czuw-092q.m2.xano.io/api:shorts/knowledge_graph/shared_certificate_details', {
        params: {
          unique_certificate_id
        }
      })

      successCallback && successCallback(response.data.data)

    } catch (e) {
      console.error(e);
      errorCallback && errorCallback(e.response.data.message);
    }
  }
}
export function getShareSkillCertificateDetails(unique_certificate_id, successCallback, errorCallback) {
  return async function (dispatch) {
    try {

      const response = await axiosNoAuth.get(API_XANO_AUTH_BASE_URL + Api_url.GetShareSkillCertificateDetails, {
        params: {
          unique_certificate_id
        }
      })

      successCallback && successCallback(response.data)

    } catch (e) {
      console.error(e);
      errorCallback && errorCallback(e.response.data.message);
    }
  }
}

export function createSkillCertificate(user_id, skill_slug, successCallback, errorCallback) {
  return async function (dispatch) {
    try {

      const response = await axiosAuth.post('https://xgfy-czuw-092q.m2.xano.io/api:certificate/create',
      {
        
          certificate_type: 'skill',
          slug : skill_slug,
        
      })
      console.log(response);

      successCallback && successCallback(response.data.data)

    } catch (e) {
      console.error(e);
      errorCallback && errorCallback(e.response.data.message);
    }
  }
}
export function getSkillCertificateLink(unique_certificate_id, file_type , successCallback, errorCallback) {
  return async function (dispatch) {

    
    try {
      if(file_type === 'image_png'){
        const response = await axiosAuth.get('https://xgfy-czuw-092q.m2.xano.io/api:certificate/file', {
          params: {
            certificate_type : "skill",
            unique_certificate_id,
            file_type
          }
        })

        successCallback && successCallback(response.data.data);
    }
    else{
      const response = await axiosAuth.get('https://xgfy-czuw-092q.m2.xano.io/api:certificate/file', {
        params: {
          certificate_type : "skill",
          unique_certificate_id,
          file_type
        }
      })

      successCallback && successCallback(response.data.data);

    }
      

    }
    catch (err) {
      console.log(err);
      errorCallback && errorCallback(err);

    }
  }
}

export function getShareSkillCertificateLink(unique_certificate_id, return_type , successCallback, errorCallback) {
  return async function (dispatch) {

    
    try {
      if(return_type === 'link'){
        const response = await axiosNoAuth.get(API_XANO_AUTH_BASE_URL + Api_url.GetShareSkillCertificateLink, {
          params: {
            unique_certificate_id,
            return_type
          }
        })

        successCallback && successCallback(response.data);
    }
    else{
      const response = await axiosNoAuth.get(API_XANO_AUTH_BASE_URL + Api_url.GetShareSkillCertificateLink, {
        responseType: 'arraybuffer',
          headers: {
            'Accept': 'image/jpeg'
          },
        params: {
          unique_certificate_id,
          return_type
        }
      })

      successCallback && successCallback(response.data);

    }
      

    }
    catch (err) {
      console.log(err);
      errorCallback && errorCallback(err);

    }
  }
}

export function unlockSkillCertificate(user_id, skill_slug, successCallback, errorCallback) {
  return async function (dispatch) {
    try {
      const response = await axiosAuth.post(API_XANO_AUTH_BASE_URL + Api_url.UnlockSkillCertificate, {
        user_id,
        skill_slug
      })
      console.log(response);
      successCallback && successCallback(response.data);
    }
    catch (err) {
      console.log(err);
      errorCallback && errorCallback(err);
    }
  }
}

export function getSkillCertificateProfileSection(user_id, successCallback, errorCallback) {
  return async function (dispatch) {
    try {
      const response = await axiosAuth.get('https://xgfy-czuw-092q.m2.xano.io/api:certificate/all', {
        params: {
          certificate_type : 'skill'
        }
      })

      console.log(response);
      successCallback && successCallback(response.data.data);

    }
    catch (err) {
      console.log(err);
      errorCallback && errorCallback(err);
    }
  }
}

export function getAggregatedCertificateCount(active_timeframe , successCallback , errorCallback){
  return async function(dispatch){

    try{
      const response = await axiosNoAuth.get(API_XANO_BASE_URL+ Api_url.GetAggregatedCertificateCount, {
        params: {
         active_timeframe
        }
      })
      successCallback && successCallback(response.data);
    }
    catch(err){
      console.log(err);
      errorCallback && errorCallback(err);
    }
  }
}

export function getCertificateReviews(successCallback ,errorCallback){
  return async function(dispatch){

    try{
      const response = await axiosNoAuth.get(API_XANO_BASE_URL + Api_url.GetCertificateReviews);

      successCallback && successCallback(response.data);

    }
    catch(err){
      
      console.log(err);
      errorCallback && errorCallback(err);
    
  }
}
}

export function updateCertificateStatus(certificate_id,type,successCallback,errorCallback){
  return async function(dispatch){
    try{

       const response = axiosAuth.post(API_XANO_AUTH_BASE_URL + Api_url.SetUserCertificateStatus , {
        certificate_id,
        type
       })

       successCallback && successCallback(response.data);
    }
    catch(err){
      console.log(err);
      errorCallback && errorCallback(err);
    }
  }
}

export function countAllCertificates(successCallback , errorCallback){
  return async function(dispatch){
    try{
      const response = await axiosAuth.get(API_XANO_BASE_URL + ':v1' + Api_url.CountAllCertificates);

      console.log(response.data);
      successCallback && successCallback(response.data);

    }
    catch(err){
      console.log(err);
      errorCallback && errorCallback(err);
    }
  }
}

export function validateCertificate(certificate_uuid, validation_method , unique_certificate_id,successCallback , errorCallback){
  return async function(dispatch){
    try{
      const response = await axiosNoAuth.get('https://xgfy-czuw-092q.m2.xano.io/api:certificate/validate',{
        params: {
          certificate_uuid,
          validation_method,
          unique_certificate_id
        }
      });

  
      successCallback && successCallback(response.data);

    }
    catch(err){
      console.log(err);
      errorCallback && errorCallback(err);
    }
  }
}


export function validateNewCertificate(unique_certificate_id,successCallback , errorCallback){
  return async function(dispatch){
    try{
      const response = await axiosNoAuth.post('https://certified-new.learntube.ai/verify_certificate',{
          unique_certificate_id
      });

  
      successCallback && successCallback(response.data);

    }
    catch(err){
      console.log(err);
      errorCallback && errorCallback(err);
    }
  }
}

export function getPersonaliseSkillData(email , current_subject,successCallback , errorCallback){
  return async function(dispatch){
    try{
      const response = await axiosNoAuth.post('https://ninjacurate.learntube.ai/fetch_user_other_courses/new_certificate_system',{
        email,
          current_subject
      });

  
      successCallback && successCallback(response.data);

    }
    catch(err){
      console.log(err);
      errorCallback && errorCallback(err);
    }
  }
}
export function getPersonaliseSyllabusData(email , subject,successCallback , errorCallback){
  return async function(dispatch){
    try{
      const response = await axiosNoAuth.post('https://ninjacurate.learntube.ai/new_certificate_system/user_course_fetch',{
          email,
          subject
      });

  
      successCallback && successCallback(response.data);

    }
    catch(err){
      console.log(err);
      errorCallback && errorCallback(err);
    }
  }
}


export function getCertificateUuid(certificate_id , certificate_type,successCallback , errorCallback){
  return async function(dispatch){
    try{
      const response = await axiosAuth.get('https://xgfy-czuw-092q.m2.xano.io/api:certificate/validate/url',{
        params: {
          certificate_id,
          certificate_type
        }
      });

  
      successCallback && successCallback(response.data);

    }
    catch(err){
      console.log(err);
      errorCallback && errorCallback(err);
    }
  }
}

